import { getValidAccessTokenWithRefresh } from "@helpers/authSession"
/**
 * Single migration-blueprint API root (no legacy API Gateway fallbacks).
 * Set REACT_APP_API_BASE_URL (preferred) or REACT_APP_V2_BACKEND_URL to your Nest base, e.g. https://api.example.com
 */

const normalizeBase = (url) => (url || "").replace(/\/+$/, "")

const getMigrationApiRoot = () => {
  const fromEnv = normalizeBase(
    process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_V2_BACKEND_URL || ""
  )
  if (fromEnv) return fromEnv
  if (process.env.NODE_ENV === "production") {
    throw new Error(
      "REACT_APP_API_BASE_URL (or REACT_APP_V2_BACKEND_URL) must be set for production admin builds."
    )
  }
  return "http://localhost:3000"
}

const API_ROOT = getMigrationApiRoot()

const authHeader = async () => {
  const token = await getValidAccessTokenWithRefresh()
  if (!token) return {}
  return { Authorization: `Bearer ${token}` }
}

export const awsmobile = {
  aws_project_region: process.env.REACT_APP_PROJECT_AWS_REGION || "",
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_ANALYTICS_REALTIME || "",
  aws_appsync_region: process.env.REACT_APP_PROJECT_AWS_REGION || "",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  API: {
    endpoints: [
      {
        name: "stuffsApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "adminsApi",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "providersApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "exhibitionsApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "souqApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "souqApiGatewayLocal",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "realestateApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "auctionGraphql",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "prefsApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "auctionsApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "biddingApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      },
      {
        name: "customersApiGateway",
        endpoint: API_ROOT,
        custom_header: () => authHeader()
      }
    ]
  },
  Auth: {
    identityPoolId: process.env.REACT_APP_AUTH_USERS_IDENTITY_ID || "",
    region: process.env.REACT_APP_AUTH_REGION || "",
    identityPoolRegion: process.env.REACT_APP_AUTH_IDENITY_POOL_REGION || "",
    userPoolId: process.env.REACT_APP_AUTH_USERS_POOL_ID || "",
    userPoolWebClientId: process.env.REACT_APP_AUTH_CLIENT_POOL_ID || ""
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_BUCKET_S3 || "",
      region: process.env.REACT_APP_BUCKET_S3_REGION || ""
    }
  }
}
